import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/networkCustomerCertificatesGet";
import { networkCustomerCertificatesGetRequestAction } from "./types";

function* networkCustomerCertificatesGet(action: networkCustomerCertificatesGetRequestAction) {
    try {
        let response = yield call(
            requestWithSubTenantIfNeeded,
            "get", 
            "network-customer-certificate"
        );

        yield put(
            actions.requestSuccess(response)
        );
        if (action.resolve) {
            yield call(action.resolve, response);
        }
    } catch (error) {
        yield put(actions.requestFailure(error));
        if (action.reject) {
            yield call(action.reject, error);
        }
    }
}

function* saga() {
    yield takeEvery(
        actions.NETWORK_CUSTOM_CERTIFICATES_GET_REQUEST,
        networkCustomerCertificatesGet
    );
}

export default saga;
